import { render, staticRenderFns } from "./a-loader.vue?vue&type=template&id=956a022e"
import script from "./a-loader.vue?vue&type=script&lang=js"
export * from "./a-loader.vue?vue&type=script&lang=js"
import style0 from "./a-loader.vue?vue&type=style&index=0&id=956a022e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports